import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  question: '¿Cuánto tiempo al día necesito?',
  answer: 'Solo 15 minutos de práctica consciente.'
}, {
  question: '¿Tengo que involucrar a mi pareja?',
  answer: 'No es necesario, el trabajo es contigo, aunque los resultados impactarán positivamente en tu relación.'
}, {
  question: '¿Es contenido explícito?',
  answer: 'No. Es un manual de neurobiología y trabajo somático elegante y profesional.'
}, {
  question: '¿Qué pasa si me salto un día?',
  answer: 'El protocolo incluye una guía de recuperación para retomar el ritmo sin culpa.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-12 px-6 bg-cream" data-id="element-34">
      <div className="max-w-3xl mx-auto" data-id="element-35">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="text-center mb-16" data-id="element-36">
          <h2 className="text-3xl md:text-4xl font-playfair text-burgundy-deep" data-id="element-37">
            Preguntas Frecuentes
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-38">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} viewport={{
            once: true
          }} className={`border rounded-sm overflow-hidden transition-colors duration-300 ${isOpen ? 'border-gold bg-white shadow-sm' : 'border-cream-dark bg-transparent'}`} data-id="element-39">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-40">
                  <span className={`font-playfair text-lg md:text-xl transition-colors duration-300 ${isOpen ? 'text-burgundy-deep' : 'text-charcoal'}`} data-id="element-41">
                    {faq.question}
                  </span>
                  <ChevronDownIcon className={`w-5 h-5 flex-shrink-0 transition-transform duration-300 ${isOpen ? 'transform rotate-180 text-gold' : 'text-charcoal/40'}`} data-id="element-42" />
                </button>

                <AnimatePresence data-id="element-43">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-44">
                      <div className="p-6 pt-0 text-charcoal/70 leading-relaxed" data-id="element-45">
                        {faq.answer}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}